export const BillingTargetMap = {
  PlanPricingUpdateBannerShow: "PlanPricingUpdateBannerShow", // Plan-调价通知 Banner 展示
  PlanPricingUpdateBannerDetailsClick: "PlanPricingUpdateBannerDetailsClick", // Plan-调价通知 Banner 点击查看详情
  PlanPricingUpdateModalCloseClick: "PlanPricingUpdateModalCloseClick", // Plan-调价详情弹窗关闭

  // Team弹窗相关
  BillingMonthly_TeamPopover_Show: "BillingMonthly_TeamPopover_Show", // 在Billing页打开Team月付版本弹窗
  BillingQuarterly_TeamPopover_Show: "BillingQuarterly_TeamPopover_Show", // 在Billing页打开Team季付版本弹窗
  BillingYearly_TeamPopover_Show: "BillingYearly_TeamPopover_Show", // 在Billing页打开Team年付版本弹窗
  BillingMonthly_TeamPopover_Close: "BillingMonthly_TeamPopover_Close", // 在Billing页关闭Team月付版本弹窗
  BillingQuarterly_TeamPopover_Close: "BillingQuarterly_TeamPopover_Close", // 在Billing页关闭Team季付版本弹窗
  BillingYearly_TeamPopover_Close: "BillingYearly_TeamPopover_Close", // 在Billing页关闭Team年付版本弹窗
  BillingMonthly_TeamPopover_BuyNow: "BillingMonthly_TeamPopover_BuyNow", // 在Billing页Team月付版本弹窗点击Buy Now按钮
  BillingQuarterly_TeamPopover_BuyNow: "BillingQuarterly_TeamPopover_BuyNow", // 在Billing页Team季付版本弹窗点击Buy Now按钮
  BillingYearly_TeamPopover_BuyNow: "BillingYearly_TeamPopover_BuyNow", // 在Billing页Team年付版本弹窗点击Buy Now按钮

  // QA展开/关闭相关
  Billing_QA_CancelPlan_Show: "Billing_QA_CancelPlan_Show", // 在Billing页展开QA-Can I cancel or change my plan anytime?
  Billing_QA_CancelPlan_Close: "Billing_QA_CancelPlan_Close", // 在Billing页关闭QA-Can I cancel or change my plan anytime?
  Billing_QA_DuplicateSearch_Show: "Billing_QA_DuplicateSearch_Show", // 在Billing页展开QA-Do I pay for duplicate searches?
  Billing_QA_DuplicateSearch_Close: "Billing_QA_DuplicateSearch_Close", // 在Billing页关闭QA-Do I pay for duplicate searches?
  Billing_QA_PayForPlan_Show: "Billing_QA_PayForPlan_Show", // 在Billing页展开QA-How can I pay for my plan?
  Billing_QA_PayForPlan_Close: "Billing_QA_PayForPlan_Close", // 在Billing页关闭QA-How can I pay for my plan?
  Billing_QA_Credits_Show: "Billing_QA_Credits_Show", // 在Billing页展开QA-What are LeadContact credits?
  Billing_QA_Credits_Close: "Billing_QA_Credits_Close", // 在Billing页关闭QA-What are LeadContact credits?
  Billing_QA_RightForBusiness_Show: "Billing_QA_RightForBusiness_Show", // 在Billing页展开QA-Is LeadContact right for my business?
  Billing_QA_RightForBusiness_Close: "Billing_QA_RightForBusiness_Close", // 在Billing页关闭QA-Is LeadContact right for my business?
  Billing_QA_MoreQuestions_Show: "Billing_QA_MoreQuestions_Show", // 在Billing页展开QA-I have more questions.
  Billing_QA_MoreQuestions_Close: "Billing_QA_MoreQuestions_Close", // 在Billing页关闭QA-I have more questions.

  // QA邮箱点击相关
  Billing_QA_PayForPlan_Julia: "Billing_QA_PayForPlan_Julia", // 在Billing页QA点击联系Julia邮箱（How can I pay for my plan?）
  Billing_QA_RightForBusiness_Julia: "Billing_QA_RightForBusiness_Julia", // 在Billing页QA点击联系Julia邮箱（Is LeadContact right for my business?）
  Billing_QA_MoreQuestions_Julia: "Billing_QA_MoreQuestions_Julia", // 在Billing页QA点击联系Julia邮箱（I have more questions.）

  // 访问页面埋点
  Billing_Page_Show_Old: "Billing_Page_Show_Old", // 在Billing页访问旧版页面
  Billing_Page_Show_New: "Billing_Page_Show_New", // 在Billing页访问新版页面
  Billing_Page_Show_V3: "Billing_Page_Show_V4", // 在Billing页访问新版页面

  // 微信支付点击相关
  Billing_Page_WeChatPay_Click_Tip_New: "Billing_Page_WeChatPay_Click_Tip_New", // 在Billing页点击微信支付横幅提示（新版）
  Billing_Page_WeChatPay_Click_Tip_Old: "Billing_Page_WeChatPay_Click_Tip_Old", // 在Billing页点击微信支付横幅提示（旧版）
  Billing_Page_WeChatPay_Click_Tip_Email_New:
    "Billing_Page_WeChatPay_Click_Tip_Email_New", // 在Billing页点击微信支付横幅提示弹窗点击联系Julia邮箱（新版）
  Billing_Page_WeChatPay_Click_Tip_Email_Old:
    "Billing_Page_WeChatPay_Click_Tip_Email_Old", // 在Billing页点击微信支付横幅提示弹窗点击联系Julia邮箱（旧版）

  // 订阅状态相关
  Subscription_Success_Popup_Display: "Subscription_Success_Popup_Display", // 订阅成功弹窗展示
  Subscription_Success_Whatsapp_Click: "Subscription_Success_Whatsapp_Click", // 订阅成功弹窗点击WhatsApp
  Subscription_Success_Whatsapp_Qr_Click: "Subscription_Success_Whatsapp_Qr_Click", // 订阅成功弹窗点击WhatsApp打开二维码
  Subscription_Success_Wechat_Click: "Subscription_Success_Wechat_Click", // 订阅成功弹窗点击WeChat
  Subscription_Success_Wechat_Qr_Click: "Subscription_Success_Wechat_Qr_Click", // 订阅成功弹窗点击WeChat打开二维码
  Subscription_Success_Email_Click: "Subscription_Success_Email_Click", // 订阅成功弹窗点击Email
  Subscription_Success_Facebook_Click: "Subscription_Success_Facebook_Click", // 订阅成功弹窗点击Facebook
  Subscription_Failed_Popup_Display: "Subscription_Failed_Popup_Display", // 订阅失败弹窗展示
  Subscription_Failed_Whatsapp_Click: "Subscription_Failed_Whatsapp_Click", // 订阅失败弹窗点击WhatsApp
  Subscription_Failed_Whatsapp_Qr_Click: "Subscription_Failed_Whatsapp_Qr_Click", // 订阅失败弹窗点击WhatsApp打开二维码
  Subscription_Failed_Wechat_Click: "Subscription_Failed_Wechat_Click", // 订阅失败弹窗点击WeChat
  Subscription_Failed_Wechat_Qr_Click: "Subscription_Failed_Wechat_Qr_Click", // 订阅失败弹窗点击WeChat打开二维码
  Subscription_Failed_Email_Click: "Subscription_Failed_Email_Click", // 订阅失败弹窗点击Email
  Subscription_Failed_Facebook_Click: "Subscription_Failed_Facebook_Click", // 订阅失败弹窗点击Facebook

  // 第三版Billing页相关
  billing_v4_cn_offer_click: "billing_v4_cn_offer_click", // 新版Billing页-点击中文特惠专区
  billing_team_contact_cs_click: "billing_team_contact_cs_click", // 新版Billing页Team版-点击联系客服
  billing_team_cs_popup_show: "billing_team_cs_popup_show", // 新版Billing页Team版-打开联系客服弹窗
  billing_team_cs_whatsapp_click: "billing_team_cs_whatsapp_click", // 新版Billing页Team版联系客服弹窗-点击添加WhatsApp
  billing_team_cs_wechat_click: "billing_team_cs_wechat_click", // 新版Billing页Team版联系客服弹窗-点击添加微信
  billing_team_cs_email_open_click: "billing_team_cs_email_open_click", // 新版Billing页Team版联系客服弹窗-点击打开本地邮箱
  billing_team_cs_email_copy_click: "billing_team_cs_email_copy_click", // 新版Billing页Team版联系客服弹窗-点击复制邮箱
  billing_team_cs_facebook_click: "billing_team_cs_facebook_click", // 新版Billing页Team版联系客服弹窗-点击打开Facebook
  billing_team_cs_close_hide: "billing_team_cs_close_hide", // 新版Billing页Team版联系客服弹窗-关闭
  billing_v1_cn_offer_show: "billing_v1_cn_offer_show", // 旧版Billing页-展示中文特惠专区
  billing_v4_cn_offer_show: "billing_v4_cn_offer_show", // 新版Billing页-展示中文特惠专区
  billing_v1_india_offer_show: "billing_v1_india_offer_show", // 旧版Billing页-展示印度特惠专区
  billing_v3_india_offer_show: "billing_v3_india_offer_show", // 新版Billing页-展示印度特惠专区
  billing_v1_india_offer_click: "billing_v1_india_offer_click", // 旧版Billing页-点击印度特惠专区
  billing_v3_india_offer_click: "billing_v3_india_offer_click", // 新版Billing页-点击印度特惠专区
  billing_v3_pakistan_offer_click: "billing_v3_pakistan_offer_click", // 新版Billing页-点击巴基斯坦特惠专区
  billing_v3_nigeria_offer_click: "billing_v3_nigeria_offer_click", // 新版Billing页-点击尼日利亚特惠专区
  billing_v1_pakistan_offer_click: "billing_v1_pakistan_offer_click", // 旧版Billing页-点击巴基斯坦特惠专区
  billing_v1_nigeria_offer_click: "billing_v1_nigeria_offer_click", // 旧版Billing页-点击尼日利亚特惠专区
  one_time_renewal_guide_plan_contact_click:
    "one_time_renewal_guide_plan_contact_click", // 一次性续费引导-Plan页点击联系客服
  one_time_renewal_guide_plan_contact_modal_show:
    "one_time_renewal_guide_plan_contact_modal_show", // 一次性续费引导-Plan页打开联系客服弹窗
  one_time_renewal_guide_plan_contact_modal_close:
    "one_time_renewal_guide_plan_contact_modal_close", // 一次性续费引导-Plan页关闭联系客服弹窗
  one_time_renewal_guide_plan_cs_whatsapp_click:
    "one_time_renewal_guide_plan_cs_whatsapp_click", // 一次性续费引导-Plan页联系客服弹窗-点击添加WhatsApp
  one_time_renewal_guide_plan_cs_wechat_click:
    "one_time_renewal_guide_plan_cs_wechat_click", // 一次性续费引导-Plan页联系客服弹窗-点击添加微信
  bone_time_renewal_guide_plan_cs_email_open_click:
    "bone_time_renewal_guide_plan_cs_email_open_click", // 一次性续费引导-Plan页联系客服弹窗-点击打开本地邮箱
  one_time_renewal_guide_plan_cs_email_copy_click:
    "one_time_renewal_guide_plan_cs_email_copy_click", // 一次性续费引导-Plan页联系客服弹窗-点击复制邮箱
};
